import React, { useCallback, useEffect } from "react";
import Button from "../Button";
import "./styles.scss";

interface IPropsModal {
  callbackCancel?: () => void;
  callbackConfirm?: () => void;
  children: React.ReactNode;
  header: React.ReactNode;
  overflow?: boolean;
  actions?: React.ReactNode;
  size?: "sm" | "md" | "lg";
  loading?: boolean;
  closeAfter?: number;
}

const Modal = ({
  callbackCancel,
  callbackConfirm,
  loading,
  children,
  header,
  overflow,
  actions,
  size = "lg",
  closeAfter,
}: IPropsModal) => {
  const closeModal = useCallback(() => {
    if (callbackCancel) {
      callbackCancel();
    }
  }, [callbackCancel]);

  useEffect(() => {
    if (closeAfter) {
      const timer = setTimeout(() => {
        closeModal();
      }, closeAfter);

      return () => clearTimeout(timer);
    }
  }, [closeAfter, closeModal]);

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  return (
    <div className="modal" onClick={handleOverlayClick}>
      <div className={`modal__content ${size}`}>
        <header>{header}</header>
        {overflow ? (
          <section style={{ overflowY: "scroll" }}>{children}</section>
        ) : (
          children
        )}
        <nav>{actions}</nav>
      </div>
    </div>
  );
};

export default Modal;
